"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { ProductDetail, Dialog } from "trimble-terra";
import "./ProductDetailLinks.css";
import { handleDecreaseQuantity, handleIncreaseQuantity, handleChangeQuantity } from "./PdpMethods";
import { useEcomStore } from "@/context/ecom/EcomContext";
import Link from "next/link";
import useEcomPage from "./hooks/useEcomPage";
import useProductDetail from "./hooks/useProductDetail";
import useAccountConfirmation from "./hooks/useAccountConfirmation";
// import useAuthCheck from "./hooks/useAuthCheck"
import { renderPopUpDialogContent, formatPricingCardsDataLayerEnglish } from "./PdpMethods";
import DatalayerPdpView from "../Datalayer/DatalayerPdpView";
import useScrollLock from "@/lib/useScrollLock";
import { ProductDetailLabels, ProductDetailCreditsLabels } from "@/queries/productDetailQueries";
import { EcomErrorMessages } from "@/queries/ecomErrorMessagesQueries";

// import {
//   ProductDetails,
//   ImageItem,
//   Product,
//   PricingCard,
//   LineItem,
// } from "@/types/ecom"

const ProductDetailConnector = t0 => {
  const $ = _c(44);
  const {
    data,
    labels,
    creditsLabels,
    errorMessages,
    locale,
    productsEnglish
  } = t0;
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState("");
  const [count, setCount] = useState(1);
  const [quantityError, setQuantityError] = useState(false);
  const [isMaxQuantityError, setIsMaxQuantityError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [, setError] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [state] = useEcomStore() ?? [];
  const [isRegionBlocked, setRegionBlocked] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [subscriptionTypeErrorNonMerge, setSubscriptionTypeErrorNonMerge] = useState(false);
  const [subscriptionTypeErrorMerge, setSubscriptionTypeErrorMerge] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useScrollLock(isOpen);
  const [addToCartError, setAddToCartError] = useState(false);
  const [isCurrencyMismatch, setIsCurrencyMismatch] = useState(false);
  const [isAccountError, setIsAccountError] = useState(false);
  const [isRestrictedError, setIsRestrictedError] = useState(false);
  const [pricingDataForDatalayer, setPricingDataForDatalayer] = useState(null);
  const [hasCartConflict, setCartConflict] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHasMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  useEcomPage();
  useAccountConfirmation();
  const isCountryExcluded = typeof data?.countriesExcluded === "string" && data?.countriesExcluded?.split(",").map(_temp).includes(state?.countryCode?.toUpperCase());
  const t3 = productsEnglish?.pim;
  let t4;
  if ($[2] !== pricingDataForDatalayer || $[3] !== productsEnglish?.secondaryProductsData || $[4] !== t3) {
    const englishPricingCards = [t3, ...(productsEnglish?.secondaryProductsData ?? [])].filter(_temp2);
    t4 = pricingDataForDatalayer ? formatPricingCardsDataLayerEnglish(englishPricingCards, pricingDataForDatalayer) : [];
    $[2] = pricingDataForDatalayer;
    $[3] = productsEnglish?.secondaryProductsData;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const englishPricingCardsForDatalayer = t4;
  let t5;
  if ($[6] !== count || $[7] !== creditsLabels || $[8] !== data || $[9] !== disabled || $[10] !== englishPricingCardsForDatalayer || $[11] !== errorMessages || $[12] !== hasCartConflict || $[13] !== isProcessing || $[14] !== labels || $[15] !== loading || $[16] !== locale || $[17] !== pricingDataForDatalayer || $[18] !== quantityError || $[19] !== selected || $[20] !== setError) {
    t5 = {
      data,
      labels,
      creditsLabels,
      errorMessages,
      setLoading,
      selected,
      setSelected,
      setIsMaxQuantityError,
      setErrorMessage,
      setError,
      disabled,
      setDisabled,
      count,
      setCount,
      setRegionBlocked,
      quantityError,
      setQuantityError,
      isProcessing,
      setIsProcessing,
      setSubscriptionTypeErrorNonMerge,
      setSubscriptionTypeErrorMerge,
      setIsOpen,
      setAddToCartError,
      setIsCurrencyMismatch,
      setIsAccountError,
      setIsRestrictedError,
      hasCartConflict,
      setCartConflict,
      pricingDataForDatalayer,
      setPricingDataForDatalayer,
      loading,
      englishPricingCardsForDatalayer,
      locale
    };
    $[6] = count;
    $[7] = creditsLabels;
    $[8] = data;
    $[9] = disabled;
    $[10] = englishPricingCardsForDatalayer;
    $[11] = errorMessages;
    $[12] = hasCartConflict;
    $[13] = isProcessing;
    $[14] = labels;
    $[15] = loading;
    $[16] = locale;
    $[17] = pricingDataForDatalayer;
    $[18] = quantityError;
    $[19] = selected;
    $[20] = setError;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = useProductDetail(t5);
  let content;
  let handleCancelReplaceCart;
  let handleReplaceCart;
  let inlineMedia;
  let pricingCards;
  if ($[22] !== t6) {
    ({
      pricingCards,
      handleReplaceCart,
      handleCancelReplaceCart,
      inlineMedia,
      ...content
    } = t6);
    if (content.images) {
      content.images = content.images.map(_temp3);
    }
    $[22] = t6;
    $[23] = content;
    $[24] = handleCancelReplaceCart;
    $[25] = handleReplaceCart;
    $[26] = inlineMedia;
    $[27] = pricingCards;
  } else {
    content = $[23];
    handleCancelReplaceCart = $[24];
    handleReplaceCart = $[25];
    inlineMedia = $[26];
    pricingCards = $[27];
  }
  let t7;
  if ($[28] !== pricingCards) {
    t7 = sku => {
      if (!sku) {
        setSelected("");
        return;
      }
      const price = pricingCards.find(card => card.sku === sku)?.price;
      if (price) {
        setSelected(sku);
      }
    };
    $[28] = pricingCards;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => handleChangeQuantity(setCount, e, setDisabled);
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== content || $[32] !== data?.optionalRegionBlockedPurchasingText || $[33] !== isRegionBlocked) {
    t9 = isRegionBlocked && data?.optionalRegionBlockedPurchasingText ? {
      text: data?.optionalRegionBlockedPurchasingText || "Interested in this software, but you are located outside the United States and Canada?",
      link: content.regionBlockedUserLink
    } : "";
    $[31] = content;
    $[32] = data?.optionalRegionBlockedPurchasingText;
    $[33] = isRegionBlocked;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const T0 = Dialog;
  const t10 = renderPopUpDialogContent({
    ...state?.globalEcommerceLabels,
    ...labels,
    ...errorMessages
  }, setIsOpen, subscriptionTypeErrorNonMerge, subscriptionTypeErrorMerge, addToCartError, setAddToCartError, isCurrencyMismatch, setIsCurrencyMismatch, isAccountError, setIsAccountError, isRestrictedError, setIsRestrictedError, isMaxQuantityError, setIsMaxQuantityError, hasCartConflict, handleReplaceCart, handleCancelReplaceCart);
  let t11;
  if ($[35] !== T0 || $[36] !== isOpen || $[37] !== t10) {
    t11 = <T0 isOpen={isOpen} {...t10} />;
    $[35] = T0;
    $[36] = isOpen;
    $[37] = t10;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== data?.pim || $[40] !== englishPricingCardsForDatalayer || $[41] !== locale || $[42] !== state) {
    t12 = data?.pim && englishPricingCardsForDatalayer && state && <DatalayerPdpView product={data?.pim} locale={locale} pricingDataForDatalayer={englishPricingCardsForDatalayer} cartData={state?.cart?.lineItems} cartId={state?.cart?.id} />;
    $[39] = data?.pim;
    $[40] = englishPricingCardsForDatalayer;
    $[41] = locale;
    $[42] = state;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  return <><div data-testid="pdp-widget"><ProductDetail Link={Link} LinkComponent={Link} content={content} inlineMedia={hasMounted && inlineMedia?.inlineMediaPanels?.length ? inlineMedia : undefined} setSelected={t7} count={count} disableBtn={disabled} isLoading={loading || !state?.isCartInitialized} isPricingLoading={loading} error={quantityError} errorMessage={errorMessage} selected={selected} handleDecreaseQuantity={() => {
        handleDecreaseQuantity(count, setQuantityError, setErrorMessage, setCount, {
          ...data,
          ...errorMessages
        }, state, selected);
      }} handleIncreaseQuantity={() => {
        handleIncreaseQuantity(count, setCount, state, selected);
      }} handleChangeQuantity={t8} isCountryExcluded={isCountryExcluded} isRegionBlocked={isRegionBlocked} purchaseUnavailableText={data?.purchaseUnavailableText || state?.globalEcommerceLabels?.regionBlockedPricingCardText || "This software is not available in your country or region"} isProcessing={isProcessing} regionBlockedPurchasingText={t9} />{t11}</div>{t12}</>;
};
export default ProductDetailConnector;
function _temp(country) {
  return country.trim().toUpperCase();
}
function _temp2(p) {
  return !!p;
}
function _temp3(image) {
  if (image.imageUrl) {
    return {
      ...image,
      imageUrl: image.imageUrl + "?w=800"
    };
  }
  return image;
}